import { User } from "@/types/user";

export function isRestricted(user: User.Info): boolean {
    if (!user) return false;
    return user.restricted.includes("template_protections");
}